export const callsData = [
  {
    key: '1',
    title: 'Busy',
    createdAt: '25 Sep 2023, 01:22 pm',
    status: 'Active',
  },
  {
    key: '2',
    title: 'No Answer',
    createdAt: '29 Sep 2023, 10:20 pm',
    status: 'Active',
  },
  {
    key: '3',
    title: 'Wrong Number',
    createdAt: '04 Oct 2023, 08:30 am',
    status: 'Active',
  },
  {
    key: '4',
    title: 'Unavailable',
    createdAt: '17 Oct 2023, 11:45 am',
    status: 'Inactive',
  },
];
